import React from 'react';

import './style.scss';

const Tip = ({ children, title }) => (
  <div className="tip">
    <div className="head">
      <h1><i className="far fa-anchor" /> {title}</h1>
    </div>
    <div className="body">{children}</div>
    <div className="clearfix" />
  </div>
);

export default Tip;
